const trim = (name = '', length = 17) => {
    if (name && name.length > length) {
        const head = name.slice(0, length);
        return `${head}...`;
    }
    return name;
};

export default trim;
